<template>
  <div class="discount-component">
    <b-nav card-header pills class="mt-1 ml-1 mb-0">
      <!-- exact-active-class="sub-tab-nav" -->
      <b-nav-item
        v-for="(item, index) in tabs"
        :key="index"
        exact
        :active="currentTab === item.key"
        :link-classes="['sub-tab-nav', 'px-3', bgTabsNavs]"
        @click="currentTab = item.key"
        :class="[currentTab === item.key ? 'active ' : 'active ']"
        >{{ $t(item.title) }}
      </b-nav-item>
    </b-nav>

    <b-card
      no-body
      class="border-top-info border-3 border-table-radius px-0 my-0 pt-0"
    >
      <DiscountTable
        v-if="currentTab === 'listado'"
        ref="rrhh-discount-table"
      />

      <DescuentosReporte v-if="currentTab === 'reporte'" />
      
      <DescuentosReporteDetalle v-if="currentTab === 'reporte_detalle'" />
    </b-card>

    <!-- :tab="getTab" -->

    <DiscountModal
      :modalData="modalData"
      v-if="discountModal"
      @hideModal="hideDiscountModal"
    />
  </div>
</template>

<script>
import DiscountTable from "@/views/commons/discounts/components/DiscountTable.vue";
import DiscountModal from "@/views/commons/discounts/components/modals/DiscountModal.vue";
import DescuentosReporte from "@/views/commons/discounts/components/DescuentosReporte.vue";
import DescuentosReporteDetalle from "@/views/commons/discounts/components/DescuentosReporteDetalle.vue";

export default {
  components: {
    DiscountTable,
    DiscountModal,
    DescuentosReporte,
    DescuentosReporteDetalle,
  },
  data() {
    return {
      discountModal: false,
      modalData: {
        id: null,
      },
      tabs: [
        {
          key: "listado",
          title: "Listado",
        },
        {
          key: "reporte",
          title: "Reporte",
        },
        {
          key: "reporte_detalle",
          title: "Reporte Detalle",
        },
      ],
      currentTab: "listado",
    };
  },
  computed: {
    // getTab() {
    //   return this.$route.meta.tab;
    // },
  },
  methods: {
    openModalDiscount() {
      this.modalData.id = null;
      this.discountModal = true;
    },
    hideDiscountModal(action = false) {
      if (action == true) {
        this.$refs["rrhh-discount-table"].refreshTable();
      }
      this.discountModal = false;
    },
  },
};
</script>

<style lang="scss">
// Por si no son rutas, para colorear los sub tabs

.discount-component {
  .b-nav {
    margin-bottom: 0 !important; // elimina espacio entre nav y card
  }

  .sub-tab-nav {
    &.active {
      background-color: #8f5fe8 !important;
      color: #fff !important;
      box-shadow: none !important;
      border-bottom: 2px solid transparent !important; // evita saltos
    }
  }

  .nav-pills {
    border-bottom: none !important;

    .nav-link {
      border-radius: 6px 6px 0 0;
      margin-bottom: -1px; // clave para unir visualmente con el card
    }

    .nav-link.active {
      border-bottom: 1px solid #8f5fe8 !important; // línea de conexión
    }
  }
}

.dark-layout {
  .discount-component {
    .nav-pills {
      border-bottom: none !important;

      .nav-link.active {
        border-bottom: 1px solid #8f5fe8 !important;
      }
    }
  }
}
</style>
